<template>
  <div class="center">
    <div class="title">{{ $t('Events.Store') }}</div>
    <div>
      <Tabs @on-click="relevanceclick" v-model="tabPage">
        <TabPane :label="$t('Events.all')" name="tab1">
        </TabPane>
        <TabPane :label="$t('Events.progress')" name="tab2">
        </TabPane>
        <TabPane :label="$t('Events.started')" name="tab3">
        </TabPane>
        <TabPane :label="$t('Events.started')" name="tab4">
        </TabPane>
      </Tabs>
    </div>
    <div class="content">
      <div>
        <Input v-model="activityName" :placeholder="$t('Events.Event')" style="width: 300px;margin-right: 10px" />
        <Input v-model="partName" :placeholder="$t('Events.Accessory')" style="width: 300px;margin-right: 10px" />
        <Select v-model="activityStatus" style="width:200px;margin-right: 10px">
          <Option v-for="item in statusList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
        <Select v-model="activityType" style="width:200px">
          <Option v-for="item in typeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
        <Button style="margin-left: 30px" @click="reset">{{ $t('Events.reset') }}</Button>
        <Button type="primary" style="margin-left: 10px" @click="getTableList">{{ $t('Events.Inquire') }}</Button>
      </div>
      <div class="table">
        <vxe-table
          :auto-resize="true"
          :data="tableData">
          <vxe-column :title="$t('Events.Activity')" field="activityId"></vxe-column>
          <vxe-column:title="$t('Events.operate')" >
            <template #default="{ row }">
              <div>
                <a href="javascript:;" @click="toCheck(row)">{{ $t('Events.Check') }}</a>
                <!-- <a href="javascript:;">结束</a> -->
              </div>
              <!-- <div>
                <a href="javascript:;">复制活动</a>
              </div> -->
            </template>
          </vxe-column:title=>
          <vxe-column :title="$t('Events.name')" field="activityName"></vxe-column>
          <vxe-column :title="$t('Events.type')" field="activityTypeName"></vxe-column>
          <vxe-column :title="$t('Inquiry.state')" field="statusName"></vxe-column>
          <vxe-column :title="$t('Events.time')">
            <template #default="{ row }">
              <div>从{{row.startTime}}</div>
              <div>至{{row.endTime}}</div>
              <div>活动持续：{{row.timeHorizon}}</div>
            </template>
          </vxe-column>
          <vxe-column :title="$t('Events.Remark')" field="remark"></vxe-column>
          <vxe-column :title="$t('Events.create')">
            <template #default="{ row }">
              <div>{{row.createUname}}</div>
              <div>{{row.createTime}}</div>
            </template>
          </vxe-column>
          <vxe-column :title="$t('Events.Modify')" >
            <template #default="{ row }">
              <div>{{row.updateUname}}</div>
              <div>{{row.updateTime}}</div>
            </template>
          </vxe-column>
        </vxe-table>
        <div  style="display: flex; justify-content: right;">
          <vxe-pager
            background
            :current-page.sync="page.page"
            :page-size.sync="page.size"
            @page-change="pageChange"
            :total="listTotal"
            :page-sizes="[30]"
            :layouts="[
              'PrevJump',
              'PrevPage',
              'JumpNumber',
              'NextPage',
              'NextJump',
              'Sizes',
              'FullJump',
              'Total'
            ]"
          >      
          </vxe-pager>
        </div>  
      </div>
    </div>

    <Modal v-model="modal" :title="$t('Events.Details')" width="800" :closable="false" style="color: #000">
      <div>
        <div style="width: 100%; border-bottom: 1px solid #e2e2e2">{{ $t('home.Information') }}</div>
        <div>
          <Row style="margin-top: 18px">
            <Col span="3">{{ $t('Invoice.Activity') }}</Col>
            <Col span="9">{{detailData.activityId}}</Col>
            <Col span="3">{{ $t('Invoice.Settings') }}</Col>
            <Col span="9">{{detailData.type}}</Col>
          </Row>
          <Row style="margin-top: 18px">
            <Col span="3">{{ $t('Invoice.name') }}</Col>
            <Col span="9">{{detailData.activityName}}</Col>
            <Col span="3">{{ $t('Invoice.Number') }}</Col>
            <Col span="9">{{detailData.count}}</Col>
          </Row>
          <Row style="margin-top: 18px">
            <Col span="3">{{ $t('Invoice.time') }}</Col>
            <Col span="21">{{detailData.startTime}}至{{detailData.endTime}}</Col>
          </Row>
          <Row style="margin-top: 18px;margin-bottom: 15px">
            <Col span="3">{{ $t('Invoice.Remark') }}</Col>
            <Col span="21">{{detailData.remark}}</Col>
          </Row>
        </div>
        <div style="padding-bottom: 8px;margin-bottom: 8px; width: 100%; border-bottom: 1px solid #e2e2e2">商品信息</div>
        <section v-if="detailData.activityType * 1 === 1">
          <div>{{ $t('Events.Purchase') }}</div>
          <Row class="tableHeader">
            <Col span="16" class="left">商品信息</Col>
            <Col span="4" class="left">库存</Col>
            <!-- <Col span="7" class="left">单价</Col> -->
            <Col span="4" class="left">活动单价</Col>
          </Row>
          <div class="tableContent" v-for="(item,ind) in storeData" :key="item.id">
            <Row justify="center" align="middle" v-if="item.isGive === 0">
              <Col span="16">
                <!-- <Row>
                  <Col span="11">
                    <img
                      v-if="item.pictureUrl"
                      :src="item.pictureUrl"
                      alt="图片缺失"
                    />
                    <img
                      v-else
                      src="@/assets/images/shoppingCart/2.png"
                      alt="图片缺失"
                      width="100%"
                    />
                  </Col>
                  <Col span="13">
                    <ul class="ul">
                      <li><span>{{item.qualityTypeName}}</span> <span>{{item.oeCode}}</span></li>
                      <li style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" :title="item.fullName">{{item.fullName}}</li>
                      <li>{{item.name}}</li>
                      <li>
                        <div class="oe-p" @mouseleave="closeRelevance(ind)">
                          <p
                            @mouseenter="getRelevance(item.id, ind, item)"
                            v-if="item.oeCodeReplacement.split(',').length"
                          >
                            OE号：{{ item.oeCodeReplacement.split(',')[0]
                            }}<i
                              class="ivu-icon ivu-icon-ios-arrow-down"
                              v-if="item.oeCodeReplacement.split(',').length > 1"
                            ></i>
                          </p>
                          <div
                            class="relevance"
                            :tabIndex="1"
                            v-if="item.oeCodeReplacement.split(',').length > 1"
                          >
                            <div
                              class="relevanceBox"
                              :class="item.isShow ? 'show' : ''"
                            >
                              <p v-for="i in item.oeCodeReplacement.split(',').slice(1)" :key="i">
                                {{ i }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </Col>
                </Row> -->
                <div style="float:left;width:90px;height:90px;">
                  <img
                    v-if="item.pictureUrl"
                    :src="item.pictureUrl"
                    alt="图片缺失"
                  />
                  <img
                    v-else
                    src="@/assets/images/shoppingCart/2.png"
                    alt="图片缺失"
                    width="100%"
                  />
                </div>
                <div>
                  <ul class="ul">
                    <li><span class="brand">{{item.qualityTypeName}}</span> <span>{{item.oeCode}}</span></li>
                    <li style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" :title="item.fullName">{{item.fullName}}</li>
                    <li>{{item.carBrandName}}</li>
                    <li>
                      <div class="oe-p" @mouseleave="closeRelevance(ind)">
                        <p
                          @mouseenter="getRelevance(item.id, ind, item)"
                          v-if="item.oeCodeReplacement.split(',').length"
                        >
                          OE号：{{ item.oeCodeReplacement.split(',')[0]
                          }}<i
                            class="ivu-icon ivu-icon-ios-arrow-down"
                            v-if="item.oeCodeReplacement.split(',').length > 1"
                          ></i>
                        </p>
                        <div
                          class="relevance"
                          :tabIndex="1"
                          v-if="item.oeCodeReplacement.split(',').length > 1"
                        >
                          <div
                            class="relevanceBox"
                            :class="item.isShow ? 'show' : ''"
                          >
                            <p v-for="i in item.oeCodeReplacement.split(',').slice(1)" :key="i">
                              {{ i }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </Col>
              <Col span="4">{{item.stock}}个</Col>
              <!-- <Col span="7">
                <ul>
                  <li v-for="(i,index) in item.partsPrices" :key="index">
                    <span>{{i.orderQuantity}}个以上:</span>
                    <span>￥{{i.price}}</span>
                  </li>
                </ul>
              </Col> -->
              <Col span="4" style="display: flex;justify-content: center;align-items: center;margin: 0 auto;">￥{{item.price}}</Col>
            </Row>  
          </div>
          <div>{{ $t('Events.Level') }}</div>
          <Row class="tableHeader">
            <Col span="16" class="left">{{ $t('Events.product') }}</Col>
            <Col span="4" class="left">{{ $t('Events.库存') }}</Col>
            <!-- <Col span="7" class="left">单价</Col> -->
            <Col span="4" class="left">{{ $t('Events.Gift') }}</Col>
          </Row>
          <div class="tableContent"  v-for="(item,ind) in storeData" :key="ind">
            <Row justify="center" align="middle" v-if="item.isGive === 1">
              <Col span="16">
                <!-- <Row>
                  <Col span="11">
                    <img
                      v-if="item.pictureUrl"
                      :src="item.pictureUrl"
                      alt="图片缺失"
                    />
                    <img
                      v-else
                      src="@/assets/images/shoppingCart/2.png"
                      alt="图片缺失"
                      width="100%"
                    />
                  </Col>
                  <Col span="13">
                    <ul class="ul">
                      <li>品牌件 {{item.oeCode}}</li>
                      <li style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" :title="item.fullName">{{item.fullName}}</li>
                      <li>{{item.carBrandName}}</li>
                      <li>
                        <div class="oe-p" @mouseleave="closeRelevance(ind)">
                          <p
                            @mouseenter="getRelevance(item.id, ind, item)"
                            v-if="item.oeCodeReplacement.split(',').length"
                          >
                            OE号：{{ item.oeCodeReplacement.split(',')[0]
                            }}<i
                              class="ivu-icon ivu-icon-ios-arrow-down"
                              v-if="item.oeCodeReplacement.split(',').length > 1"
                            ></i>
                          </p>
                          <div
                            class="relevance"
                            :tabIndex="1"
                            v-if="item.oeCodeReplacement.split(',').length > 1"
                          >
                            <div
                              class="relevanceBox"
                              :class="item.isShow ? 'show' : ''"
                            >
                              <p v-for="i in item.oeCodeReplacement.split(',').slice(1)" :key="i">
                                {{ i }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </Col>
                </Row> -->
                <div style="float:left;width:90px;height:90px;">
                  <img
                    v-if="item.pictureUrl"
                    :src="item.pictureUrl"
                    alt="图片缺失"
                  />
                  <img
                    v-else
                    src="@/assets/images/shoppingCart/2.png"
                    alt="图片缺失"
                    width="100%"
                  />
                </div>
                <div>
                  <ul class="ul">
                    <li><span class="brand">{{item.qualityTypeName}}</span> <span>{{item.oeCode}}</span></li>
                    <li style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" :title="item.fullName">{{item.fullName}}</li>
                    <li>{{item.carBrandName}}</li>
                    <li>
                      <div class="oe-p" @mouseleave="closeRelevance(ind)">
                        <p
                          @mouseenter="getRelevance(item.id, ind, item)"
                          v-if="item.oeCodeReplacement.split(',').length"
                        >
                          OE号：{{ item.oeCodeReplacement.split(',')[0]
                          }}<i
                            class="ivu-icon ivu-icon-ios-arrow-down"
                            v-if="item.oeCodeReplacement.split(',').length > 1"
                          ></i>
                        </p>
                        <div
                          class="relevance"
                          :tabIndex="1"
                          v-if="item.oeCodeReplacement.split(',').length > 1"
                        >
                          <div
                            class="relevanceBox"
                            :class="item.isShow ? 'show' : ''"
                          >
                            <p v-for="i in item.oeCodeReplacement.split(',').slice(1)" :key="i">
                              {{ i }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </Col>
              <Col span="4">{{item.stock}}个</Col>
              <!-- <Col span="7" >
                <ul>
                  <li v-for="(i,index) in item.partsPrices" :key="index">
                    <span>{{i.orderQuantity}}个以上:</span>
                    <span>￥{{i.price}}</span>
                  </li>
                </ul>
              </Col> -->
              <Col span="4" style="display: flex;justify-content: center;align-items: center;margin: 0 auto">￥18.00</Col>
            </Row>  
          </div>
        </section>
        <section style="overflow: hidden" v-else>
          <Row class="tableHeader">
            <Col span="16" class="left">{{ $t('Events.product') }}</Col>
            <!-- <Col span="7" class="left">单价</Col> -->
            <Col span="4" class="left">{{ $t('Events.Starting') }}</Col>
            <Col span="4" class="left">{{ $t('Events.price') }}</Col>
          </Row>
          <div style="margin: 10px 0">
            <Input v-model="part" :placeholder="$t('Events.name')" style="width: 300px;margin-right: 10px" />
            <Button type="primary" style="margin-left: 10px" @click="toPartSearch">{{ $t('Events.search') }}</Button>
          </div>
          <div class="box" v-for="(item,ind) in storeData" :key="ind">
            <Row justify="center" align="middle" :gutter="16">
              <Col span="16">
                <!-- <Row>
                  <Col span="11">
                    <img
                      v-if="item.pictureUrl"
                      :src="item.pictureUrl"
                      alt="图片缺失"
                    />
                    <img
                      v-else
                      src="@/assets/images/shoppingCart/2.png"
                      alt="图片缺失"
                      width="100%"
                    />
                  </Col>
                  <Col span="13">
                    <ul class="ul">
                      <li>品牌件 {{item.oeCode}}</li>
                      <li style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" :title="item.fullName">{{item.fullName}}</li>
                      <li>{{item.name}}</li>
                      <li>
                        <div class="oe-p" @mouseleave="closeRelevance(ind)">
                          <p
                            @mouseenter="getRelevance(item.id, ind, item)"
                            v-if="item.oeCodeReplacement.split(',').length"
                          >
                            OE号：{{ item.oeCodeReplacement.split(',')[0]
                            }}<i
                              class="ivu-icon ivu-icon-ios-arrow-down"
                              v-if="item.oeCodeReplacement.split(',').length > 1"
                            ></i>
                          </p>
                          <div
                            class="relevance"
                            :tabIndex="1"
                            v-if="item.oeCodeReplacement.split(',').length > 1"
                          >
                            <div
                              class="relevanceBox"
                              :class="item.isShow ? 'show' : ''"
                            >
                              <p v-for="i in item.oeCodeReplacement.split(',').slice(1)" :key="i">
                                {{ i }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </Col>
                </Row> -->
                <div style="float:left;width:90px;height:90px;">
                  <img
                    v-if="item.pictureUrl"
                    :src="item.pictureUrl"
                    alt="图片缺失"
                  />
                  <img
                    v-else
                    src="@/assets/images/shoppingCart/2.png"
                    alt="图片缺失"
                    width="100%"
                  />
                </div>
                <div>
                  <ul class="ul">
                    <li><span class="brand">{{item.qualityTypeName}}</span> <span>{{item.oeCode}}</span></li>
                    <li style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" :title="item.fullName">{{item.fullName}}</li>
                    <li>{{item.carBrandName}}</li>
                    <li>
                      <div class="oe-p" @mouseleave="closeRelevance(ind)">
                        <p
                          @mouseenter="getRelevance(item.id, ind, item)"
                          v-if="item.oeCodeList.length"
                        >
                          OE号：{{ item.oeCodeList[0]
                          }}<i
                            class="ivu-icon ivu-icon-ios-arrow-down"
                            v-if="item.oeCodeList.length > 1"
                          ></i>
                        </p>
                        <div
                          class="relevance"
                          :tabIndex="1"
                          v-if="item.oeCodeList.length > 1"
                        >
                          <div
                            class="relevanceBox"
                            :class="item.isShow ? 'show' : ''"
                          >
                            <p v-for="i in item.oeCodeList.slice(1)" :key="i">
                              {{ i }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </Col>
              <!-- <Col span="7" >
                <ul>
                  <li v-for="(i,index) in item.partsPrices" :key="index">
                    <span>{{i.orderQuantity}}个以上:</span>
                    <span>￥{{i.price}}</span>
                  </li>
                </ul>
              </Col> -->
              <Col span="4">{{item.giveNum}}个</Col>
              <Col span="4" style="display: flex;justify-content: center;align-items: center;margin: 0 auto">￥{{item.activityPrice}}</Col>
            </Row>
          </div>
          <div style="float: right;margin-top: 8px">
            <Page :total="detailTotal" show-total @on-change="detailPageChange" />
          </div>
        </section>
      </div>
      <template #footer>
        <div style="text-align: center">
          <Button type="primary" @click="closeModal">{{ $t('Events.closure') }}</Button>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import { getList, getDetail } from '@/api/myweb/storeActivity/index.js'
import { listData } from '@/views/base/common/listData.js'
export default {
  name: 'storeActivity',
  mixins: [listData],
  data() {
    return {
      tabPage: 'tab1', // tab切换栏
      activityName: '', // 活动名称(列表页)
      partName: '', // 配件编码/配件名称(列表页)
      modal: false, // 弹框
      activityStatus: '0', // 活动状态
      activityType: '0', // 活动类型
      statusList: [
        {label: '活动状态', value: '0'},
        {label: '进行中', value: '1'},
        {label: '待开始', value: '2'},
        {label: '已结束', value: '3'},
        {label: '已取消', value: '4'}
      ],
      typeList: [
        {label: '活动类型', value: '0'},
        {label: '买赠', value: '1'},
        {label: '单品促销', value: '2'},
        {label: '组合促销', value: '3'},
      ],
      listTotal: 0, // 列表总条数
      page: {
        page: 1,
        size: 30
      },  // 列表分页
      detailPage: {
        page: 1,
        size: 30
      }, // 单框详情分页
      part: '', // 活动名称(弹框内)
      tableData: [], // 列表数据
      detailData:{}, // 弹框详情(列表项)
      storeData: [], // 弹框详情(商品项)
      detailTotal: 0 // 弹框总条数
    }
  },
  created() {
    this.getTableList()
  },
  methods: {
    // oe展开
    getRelevance(id, index, item) {
      this.$set(this.storeData[index], 'isShow', true)
    },
    // 关闭oe
    closeRelevance(index) {
      this.$set(this.storeData[index], 'isShow', false)
    },
    // 获取table列表
    async getTableList() {
      let data = {
        activityName: this.activityName,
        part: this.partName,
        activityType: this.activityType === "0" ? '' : this.activityType,
        status: this.activityStatus === "0" ? '' : this.activityStatus,
      }
      let page = {
        page: this.page.page,
        size: this.page.size
      }
      let res = await getList(data, page)
      if(res.status){
        this.listTotal = res.data.total
        // this.tableData = Array(90).fill(res.data.records[0])
        this.tableData = res.data.records
      }
    },
    // 重置搜索条件
    reset() {
      this.activityName = ''
      this.partName = ''
      this.activityType = '0'
      this.activityStatus = '0'
    },
    // 列表分页
    pageChange(v) {
      this.page.page = v
      this.getTableList()
    },
    // 查看详情
    detailPageChange(v) {
      this.detailPage.page = v
      this.toDetail(this.detailData)
    },
    // tab栏切换
    relevanceclick() {
      switch(this.tabPage){
        case 'tab1': this.activityStatus = '0'
          break;
        case 'tab2': this.activityStatus = '1'
          break; 
        case 'tab3': this.activityStatus = '2'
          break; 
        case 'tab4': this.activityStatus = '3'
          break; 
      }
      this.getTableList()
    },
    // 点击查看
    toCheck(val) {
      this.modal = true
      this.detailPage = {
        page: 1,
        size: 30
      } // 单框详情分页
      this.toDetail(val)
    },
    // 弹框详情接口
    async toDetail(val) {
      this.detailData = val
      let data = {
        activityId: val.activityId,
        part: this.part
      }
      let res = await getDetail(data,this.detailPage)
      if(res.status){
        this.storeData = res.data.records
        this.detailTotal = res.data.total
      }
      console.log(this.detailData,'---');
    },
    // 弹框详情内搜索
    toPartSearch() {
      this.toDetail(this.detailData)
    },
    // 关闭弹框
    closeModal() {
      if(this.part) this.part = ""
      this.modal = false
    }
  }
}
</script>
<style lang="less" scoped>
  .center {
    width: 100%;
    .title {
      background-color: #fff;
      padding: 10px;
      font-size: 16px;
      font-weight: 700;
    }
    .content {
      background-color: #fff;
      padding: 10px;
      .table {
        margin-top: 30px;
        a{
          color: #2d8cf0;
          margin-left: 5px
        }
      }
    }
  }
  .tableHeader {
    padding: 0 10px;
    height: 41px;
    line-height: 40px;
    border: 1px solid #e2e2e2;
    border-radius: 0px;
    font-size: 14px;
    text-align: center;
    font-family: Source Han Sans CN;
    font-weight: bold;
    // color: #505050;
    background-color: #f6f6f6;
  }
  .tableContent {
    padding: 10px;
    border: 1px solid #e2e2e2;
    border-top: none
  }
  .left{
    text-align: left;
  }
  .box {
    padding: 10px;
    border: 1px solid #e2e2e2;
  }
  .oe-p {
    font-size: 14px;
    // padding-top: 19px;
    // padding-left: 4px;
    // color: #505050;
    position: relative;
    p {
      text-align: left;
      font-size: 14px;
      // color: #505050;
      // cursor: pointer;
    }
    p:hover .ivu-icon-ios-arrow-down {
      transform: rotate(-180deg);
    }
    .ivu-icon-ios-arrow-down {
      font-size: 14px;
      cursor: pointer;
      transition: all 0.5s ease 0s;
    }
    .ivu-icon-ios-arrow-down:hover {
      transform: rotate(-180deg);
    }
    // .relevance {
    // cursor: pointer;
    // position: relative;
    // width: 20px;
    // margin: 0 5px;
    // img {
    //   width: 18px;
    //   height: 18px;
    // }
    // .icon-xiaodengpao {
    //   color: #b9b9b9;
    // }
    span {
      cursor: pointer;
    }
    .relevanceBox {
      // display: flex;
      padding: 2px 15px 2px 2px;
      position: absolute;
      top: 22px;
      left: 43px;
      // width: 100px;
      height: auto;
      border: 1px solid #e2e2e2;
      background-color: #fff;
      display: none;
      z-index: 99;
      overflow-y: auto;
      word-wrap: break-word;
      span {
        font-size: 12px;
        line-height: 18px;
        font-weight: normal;
        // display: inline-block;
        padding-bottom: 6px;
      }
    }
    .show {
      display: block;
    }
    // }
  }
  .ul {
    padding-left: 20px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    li {
      line-height: 30px;
      .brand{
        border-radius: 5px;
        display: inline-block;
        width: 75px;
        background-color: #f59a23;
        text-align: center;
        color: #fff;
        margin-right: 18px;
      }
    }
  }
</style>